import config from '@/config';
import useTranslations from '@/i18n/useTranslations';
import ContinueButton from '@/shared-components/buttons/components/ContinueButton';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import GenericPopup from '@/shared-components/popups/components/GenericPopup';
import Text from '@/shared-components/text/components/Text';

import './styles/RemovePicturePopup.css';

/** This component receives the handler for removing the data 
 * (each component is responsible for giving this one the correct way to remove the picture)
 */
export default function RemovePicturePopup({ open, close, pictureData, removePicture }) {
  const t = useTranslations('common.forms.add_artwork');
  return (
    <GenericPopup 
      open={open} 
      opacity 
      className="add-artwork-remove-picture-popup" 
      backgroundClassName="add-artwork-remove-picture-popup-background"
    >
      <div className="add-artwork-remove-picture-popup__header">
        <Text className="add-artwork-remove-picture-popup_header_text" paragraph>
          {t('media.delete_image_question')}
        </Text>

        <XIcon
          className="add-artwork-remove-picture-popup_close"
          onClick={close}
        />
      </div>
      <div className="add-artwork-remove-picture-popup__picture-details-container">
        <img 
          src={`${config.app.imageServiceDomain}/${pictureData?.image_id}/w=200`} 
          alt={t('media.artwork_image_alt')}
          className="add-artwork-remove-picture-popup__picture-details-picture" 
        />
        <Text className="add-artwork-remove-picture-popup__picture-details-picture-name" paragraph>
          {pictureData?.image_original_data?.name || t('media.artwork_image_fallback')}
        </Text>
      </div>
      <div className="add-artwork-remove-picture-popup__actions">
        <ContinueButton onClick={close} className="continue-button_two">
          {t('media.keep_image')}
        </ContinueButton>

        <ContinueButton onClick={removePicture} className="continue-button_two">
          {t('media.confirm_delete')}
        </ContinueButton>
      </div>
    </GenericPopup>
  );
}
